export const removeTrailingSlash = (input: string): string =>
  safeString(input).replace(/\/$/, '');

export const removeStartingSlash = (input: string): string =>
  safeString(input).replace(/^\//, '');

function safeString(input: string): string {
  return input || '';
}
